import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import * as React from "react";

export default function DateAndTimePicker({ value, disabled, setValue, min, max, is24HourFormat = false }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        sx={{ width: "100%" }}
        minDateTime={min && dayjs(min).isValid() ? dayjs(min) : undefined}
        disabled={disabled}
        maxDateTime={max && dayjs(max).isValid() ? dayjs(max) : undefined}
        size="small"
        value={value && dayjs(value).isValid() ? dayjs(value) : null}
        onChange={(newValue) => setValue(newValue)}
        format={is24HourFormat ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD hh:mm A"}
        ampm={!is24HourFormat}
      />
    </LocalizationProvider>
  );
}
